/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: types/voicemailSettings.types.ts
 🗓️ Created: 2025-01-27
 🧩 Description:
    TypeScript type definitions for Voicemail Settings module.
────────────────────────────────────────────────────────────────*/

/**
 * Voicemail Settings from database
 */
export interface VoicemailSettings {
  id: number | null;
  uuid: string | null;
  settings: {
    max_message_length: number;
    min_message_length: number;
    greetings_length: number;
    max_silence: number;
    max_login_attempts: number;
    backup_deleted: number;
    max_messages: number;
    locale: string;
    move_heard_msg: boolean;
    force_name: boolean;
    force_greetings: boolean;
    use_directory: boolean;
    review_msg: boolean;
    email_date_format: string;
  };
  createdAt: string | null;
  createdBy: number | null;
  updatedAt: string | null;
  updatedBy: number | null;
}

/**
 * Voicemail Settings Response
 */
export interface VoicemailSettingsResponse {
  success: boolean;
  data: VoicemailSettings;
  message?: string;
}

/**
 * Voicemail Settings Payload (for create/update)
 */
export interface VoicemailSettingsPayload {
  settings: {
    maxMessageLength?: number;
    minMessageLength?: number;
    greetingsLength?: number;
    maxSilence?: number;
    maxLoginAttempts?: number;
    backupDeleted?: number;
    maxMessages?: number;
    locale?: string;
    moveHeardMsg?: boolean;
    forceName?: boolean;
    forceGreetings?: boolean;
    useDirectory?: boolean;
    reviewMsg?: boolean;
    emailDateFormat?: string;
  };
}

/**
 * Voicemail Settings Form Data
 */
export interface VoicemailSettingsFormData {
  maxMessageLength: number;
  minMessageLength: number;
  greetingsLength: number;
  maxSilence: number;
  maxLoginAttempts: number;
  backupDeleted: number;
  maxMessages: number;
  locale: string;
  moveHeardMsg: boolean;
  forceName: boolean;
  forceGreetings: boolean;
  useDirectory: boolean;
  reviewMsg: boolean;
  emailDateFormat: string;
}

/**
 * Default form data
 */
export const DEFAULT_FORM_DATA: VoicemailSettingsFormData = {
  maxMessageLength: 180,
  minMessageLength: 5,
  greetingsLength: 60,
  maxSilence: 10,
  maxLoginAttempts: 3,
  backupDeleted: 100,
  maxMessages: 9999,
  locale: 'en_US',
  moveHeardMsg: true,
  forceName: false,
  forceGreetings: false,
  useDirectory: true,
  reviewMsg: true,
  emailDateFormat: '%A, %B %d %Y, %R',
};

